import React, { useMemo } from 'react';
import cx from 'classnames';
import { Icon } from 'js/components';
import {
  formatScore,
  formatWeightFraction,
  scoreIcon,
  scoreIconColor,
  toFiniteNumber,
} from '../RubricTreemap/rubricTreemapUtils';
import styles from './RubricScores.module.scss';

export default function RubricScores({ questionSets }) {
  const normalizedQuestionSets = questionSets || [];
  const totalQuestionSetWeight = normalizedQuestionSets.reduce(
    (sum, questionSet) => {
      const setWeight = toFiniteNumber(questionSet.weight);
      return setWeight == null ? sum : sum + setWeight;
    },
    0
  );

  const questionSetClasses = useMemo(() => {
    return cx(styles['question-set'], 'palette-tiers-1', 'muted-bg');
  }, []);

  return normalizedQuestionSets.length > 0 ? (
    <div className={styles['rubric-scores']}>
      <div className={styles.header}>
        <div className={styles['name']}></div>
        <div className={styles['score']}>Score</div>
        <div className={styles['weight']}>Weight</div>
      </div>
      {normalizedQuestionSets.map((questionSet) => {
        const setKey = questionSet.id || questionSet.key || questionSet.name;
        const questions = questionSet.questions || [];
        const totalQuestionWeight = questions.reduce((sum, question) => {
          const questionWeight = toFiniteNumber(question.weight);
          return questionWeight == null ? sum : sum + questionWeight;
        }, 0);

        return (
          <React.Fragment key={setKey}>
            <div className={questionSetClasses}>
              <div className={styles['name']}>
                {questionSet.name || questionSet.key || '—'}
              </div>
              <div className={styles['score']}>
                <Icon
                  icon={scoreIcon(questionSet.score, { solid: true })}
                  className={cx('icon icon-left', styles['score-icon'])}
                  style={{
                    color: scoreIconColor(questionSet.score, {
                      colorize: true,
                    }),
                  }}
                  fixedWidth
                />
                {formatScore(questionSet.score)}
              </div>
              <div className={styles['weight']}>
                {formatWeightFraction(
                  questionSet.weight,
                  totalQuestionSetWeight
                )}
              </div>
            </div>
            <div className={styles['question-set-questions']}>
              {questions.map((question, i) => (
                <div
                  className={styles.question}
                  key={
                    question.id ||
                    question.key ||
                    question.text ||
                    question.label
                  }
                >
                  <div className={styles['name']}>
                    {question.text ||
                      question.label ||
                      question.name ||
                      question.key ||
                      'Question'}
                  </div>
                  <div className={styles['score']}>
                    <Icon
                      icon={scoreIcon(question.score, { solid: true })}
                      className={cx('icon icon-left', styles['score-icon'])}
                      style={{
                        color: scoreIconColor(question.score, {
                          colorize: true,
                        }),
                      }}
                      fixedWidth
                    />
                    {formatScore(question.score)}
                  </div>
                  <div className={styles['weight']}>
                    {formatWeightFraction(question.weight, totalQuestionWeight)}
                  </div>
                </div>
              ))}
            </div>
          </React.Fragment>
        );
      })}
    </div>
  ) : null;
}
